<template>
  <div id="pin-infos">
    <img v-if="pin.photo.url" :src="pin.photo.url" class="pin_photo" alt="" height="300" width="400">
    <div id="pin-text-data">
      <h2>{{ pin.name }}</h2>
      <div id="position">{{ pin.position.lat }}, {{ pin.position.lng }}</div>
      <table id="pin_fields">
        <tr v-if="pin.city" id="city_field" class="field">
          <td class="field_name">Ville</td>
          <td class="field_value">{{ pin.city }}</td>
        </tr>
        <tr v-if="pin.region" id="region_field" class="field">
          <td class="field_name">Region</td>
          <td class="field_value">{{ pin.region }}</td>
        </tr>
        <tr v-if="pin.country" id="country_field" class="field">
          <td class="field_name">Pays</td>
          <td class="field_value">{{ pin.country }}</td>
        </tr>
        <tr v-if="pin.visited" id="visited_field" class="field">
          <td class="field_name">Visite !</td>
        </tr>
        <tr v-if="pin.to_visit_again" id="visited_again_field" class="field">
          <td class="field_name">Je veux y retourner !</td>
        </tr>
      </table>
      <h3>Commentaires</h3>
      <p>{{ pin.comments }}</p>
    </div>
    <div id="pin-action-buttons">
      <a href="#" class="box button main-button" @click.prevent="$emit('edit-pin', pin)">Editer</a>
      <a href="#" class="box button secure-button" @click.prevent="requestDeletePin">Supprimer</a>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  pin: {
    type: Object,
    required: true,
  },
})

const emit = defineEmits(['delete-pin', 'edit-pin'])

function requestDeletePin() {
  if (window.confirm(`Etes-vous sur de vouloir supprimer '${props.pin.name}' ?`)) {
    emit('delete-pin', props.pin)
  }
}
</script>
